<template>
  <div>
    <base-header type="gradient-info" class=" header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <div class="row">
        <div class="col-lg-12">
          <h1 class="display-2 text-white">{{league.Name}}</h1>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <card>
            <div slot="header" class="row d-flex align-items-center">
              <div class="col-lg-9">
                <h3 class="mb-0">Enter Scores</h3>
              </div>
              <div class="col-lg-3">
                <Multiselect
                  :options="weeks"
                  trackBy="id"
                  :customLabel="weekLabel"
                  v-model="selectedWeekModel"
                />
              </div>
            </div>

            <div v-if="selectedWeek && (selectedWeek.livePlayoff || selectedWeek.movingWeek)">
              <PlayoffScoreCard
                class="player"
                v-for="team in teams"
                :key="team.id"
                :week="selectedWeek"
                :league="league"
                :team="team"
                ref="scorecards"
              />
            </div>
            <div v-else>
              <MatchScoreCard
                class="player"
                v-for="match in matches"
                :key="match.id"
                :match="match"
                :week="selectedWeek"
                :league="league"
                @saved="onMatchSave"
                @updated="onMatchUpdated"
                ref="scorecards"
              />
            </div>

            <div class="row" v-if="selectedWeek && !selectedWeek.livePlayoff">
              <div class="col-lg-12 text-right">
                <base-button
                  type="success"
                  @click="saveAllScores"
                >
                  Save All
                </base-button>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>

    <modal
      :show.sync="modals.changeWeekConfirm"
      gradient="danger"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">Are you sure?</h6>

      <div class="py-3 text-center">
        <i class="fa fa-exclamation-triangle fa-3x"></i>
        <h4 class="heading mt-4">Warning</h4>
        <p>You have unsaved changes for Week {{selectedWeekNumber}}.
          Would you like to proceed without saving?</p>
      </div>

      <template slot="footer">
        <base-button
          type="white"
          @click="discardAndContinue"
        >
          Discard & Continue
        </base-button>
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="modals.changeWeekConfirm = false; selectedWeekModel = selectedWeek;"
        >
          Stay
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import moment from 'moment';
import MatchScoreCard from '@/components/MatchScoreCard.vue';
import PlayoffScoreCard from '@/components/PlayoffScoreCard.vue';
import ErrorHandler from '@/helpers/AuthError';

export default {
  name: 'AddTeamLeagueScores',
  components: {
    Multiselect,
    MatchScoreCard,
    PlayoffScoreCard,
  },
  props: {
    id: String,
  },
  data() {
    return {
      selectedWeek: null,
      selectedWeekModel: null,
      league: {
        id: '',
      },
      weeks: [],
      matches: [],
      modals: {
        changeWeekConfirm: false,
      },
      teams: [],
    };
  },
  mounted() {
    this.refreshLists()
      .then(() => {
        this.selectedWeek = this.currentWeek;
        this.selectedWeekModel = this.currentWeek;
      });
  },
  computed: {
    currentWeek() {
      let theWeek = null;
      for (const week of this.weeks) {
        if (moment(week.Start).isBefore(moment())
          && moment(week.Start).add(7, 'days').isAfter(moment())
        ) {
          theWeek = week;
          break;
        }
      }
      if (theWeek === null) {
        let index = 0;
        for (const week of this.weeks) {
          if (moment(week.Start).isAfter(moment()) && index > 0) {
            theWeek = this.weeks[index - 1];
            break;
          }
          index++;
        }
      }
      if (theWeek === null) {
        theWeek = this.weeks[0];
      }

      return theWeek;
    },
    selectedWeekNumber() {
      return this.selectedWeek !== null ? this.selectedWeek.WeekNumber : null;
    },
  },
  watch: {
    selectedWeekModel() {
      if (this.areAllScoresSaved()) {
        this.selectedWeek = this.selectedWeekModel;
      } else {
        this.modals.changeWeekConfirm = true;
      }
    },
    selectedWeek() {
      this.getTeams()
        .then(() => {
          if (!this.selectedWeek.livePlayoff) {
            this.getMatches();
          } else {
            this.getTeams();
          }
        });
    },
  },
  methods: {
    onMatchSave() {
      console.log('MATCH SAVED');
      this.refreshLists()
        .then(() => this.getMatches());
    },
    onMatchUpdated() {
      this.refreshLists()
        .then(() => this.getMatches());
    },
    discardAndContinue() {
      this.$refs.scorecards.forEach((card) => {
        if (card.status.text === 'UNSAVED') {
          card.discard();
        }
      });
      this.modals.changeWeekConfirm = false;
      this.selectedWeek = this.selectedWeekModel;
    },
    areAllScoresSaved() {
      let result = true;
      if (!this.$refs.scorecards) {
        return result;
      }
      this.$refs.scorecards.forEach((card) => {
        if (card.status && card.status.text === 'UNSAVED') {
          result = false;
        }
      });
      return result;
    },
    saveAllScores() {
      this.$refs.scorecards.forEach((card) => {
        if (card.status.text === 'UNSAVED') {
          card.save();
        }
      });
    },
    refreshLists() {
      this.getLeague();
      this.getTeams();
      return this.getWeeks();
    },
    weekLabel(week) {
      return `Week ${week.WeekNumber} - ${week.course ? week.course.Name : 'No Course'}`;
    },
    getLeague() {
      return this.axios
        .get(`/leagues/${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.league = response.data;
          this.league.weeks = this.league.weeks.sort((a, b) => a.WeekNumber - b.WeekNumber);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getWeeks() {
      return this.axios
        .get(`/weeks?league_eq=${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.weeks = response.data;
          this.weeks = this.weeks.sort((a, b) => a.WeekNumber - b.WeekNumber);
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getMatches() {
      console.log(this.selectedWeek);
      return this.axios
        .get(`/matches?week_eq=${this.selectedWeek.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.matches = response.data;
          this.matches.forEach((match, index) => {
            const matchTeams = [];
            match.teams.forEach((team) => {
              matchTeams.push(this.getTeamFromTeams(team.id));
            });
            this.matches[index].teams = matchTeams;
          });
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
    getTeams() {
      return this.axios
        .get(`/teams?league_eq=${this.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.teams = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getTeamFromTeams(id) {
      let result = null;
      this.teams.forEach((team) => {
        if (team.id === id) {
          result = team;
        }
      });
      return result;
    },
  },
};
</script>
<style lang="scss" scoped>
  .player{
    margin-bottom: 1rem;
  }
  .avatar{
    width: 60px;
    height: 60px;
  }
  .avatar img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
